// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-body[data-v-edefa89c] {\n  padding-top: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
